import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useVirtualToggle } from '@sorare/core/src/hooks/useVirtualToggle';
import { useVirtualToggleManager } from '@sorare/core/src/hooks/useVirtualToggleManager';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';
import {
  PlayerSearchViewAttributes,
  StatsMode,
} from '@sorare/core/src/lib/playerSearchView';
import { categoryLabels } from '@sorare/core/src/lib/scoring';

import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

const FILTER = VIRTUAL_TOGGLE_FILTERS.statsModeFilter;
const CapitalizeFirstLetter = styled.span`
  text-transform: capitalize;
`;
export const ToggleBaseballStatsMode = () => {
  const { sport } = useSportContext();
  const track = useEvents();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();
  const setVirtualToggle = useVirtualToggleManager();

  const { currentRefinement } = useVirtualToggle<string>({
    name: FILTER.name,
  });

  const newValue = !currentRefinement;

  const statsMode = statsManager[PlayerSearchViewAttributes.STATS_MODE];
  const onStatsModeChange = (s: StatsMode) => {
    updatePlayerSearchViewAttribute(PlayerSearchViewAttributes.STATS_MODE, s);
    setVirtualToggle({
      [FILTER.name]: s,
    });
    track('Use Market Filter', {
      filterName: FILTER.trackingName,
      filterValue: newValue.toString(),
    });
  };

  if (sport !== Sport.BASEBALL || statsMode === StatsMode.DEFAULT) return null;
  const sm = statsManager[PlayerSearchViewAttributes.STATS_MODE];

  if (currentRefinement !== sm) {
    setVirtualToggle({
      [FILTER.name]: statsManager[PlayerSearchViewAttributes.STATS_MODE],
    });
  }

  return (
    <TextSwitch
      value={statsMode}
      compact
      onChange={v => onStatsModeChange(v)}
      options={[
        {
          label: (
            <CapitalizeFirstLetter>
              <FormattedMessage {...categoryLabels.HITTING} />
            </CapitalizeFirstLetter>
          ),
          value: StatsMode.HITTING,
        },
        {
          label: (
            <CapitalizeFirstLetter>
              <FormattedMessage {...categoryLabels.PITCHING} />
            </CapitalizeFirstLetter>
          ),
          value: StatsMode.PITCHING,
        },
      ]}
    />
  );
};
